const icon = new URL('../../icons/3d-container.png', import.meta.url).href

export default {
  type: '3d-container',
  description: '3D Container',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: '3d-container',
    left: 100,
    top: 100,
    width: 800,
    height: 600,
    fillStyle: 'darkgray',
    fov: 60,
    near: 10,
    far: 10000,
    zoom: 100,
    threed: false
  }
}
